import React from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom-v5-compat";

import { PageContent, PrimaryAction, LinkButton } from "../Atoms";
import { useSession } from "../Session/SessionContext";
import { useVenue } from "../VenueContext";

const OrderPlaced = () => {
  const { t } = useTranslation();
  const session = useSession();
  const venue = useVenue();
  const { orderId } = useParams();
  if (!session.customerTab) return <div>no tab</div>;
  const placedOrder = session.customerTab.orders.find(
    (order) => order.uuid === orderId
  );
  if (!placedOrder) return <div>no order</div>;

  const primaryAction = (
    <LinkButton to="/your-order/pending" primary>
      {t("orderConfirmed.backToTab")}
    </LinkButton>
  );
  return (
    <PageContent className="space-y-32 ">
      <div className="max-w-md mx-auto md:space-y-64 ">
        <div>
          <div className="flex-1 space-y-16 text-center">
            <div className="font-semibold text-lg">
              {" "}
              {t("orderConfirmed.yourOrderNumberIs")}
            </div>
            <div className="text-3xl font-bold text-center">
              {placedOrder.orderNumber}
            </div>
            <div className="text-2xl font-semibold">
              {t("orderConfirmed.orderWillBeReadySoon", {
                venueName: venue.name,
              })}
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="flex-1 flex flex-col min-h-256 h-full justify-between">
            <div className="hidden md:block"> {primaryAction}</div>
            <PrimaryAction>{primaryAction}</PrimaryAction>
          </div>
        </div>
      </div>
    </PageContent>
  );
};
export default OrderPlaced;
